module.exports = __webpack_public_path__ + "static/media/loginicon.8e6184ff.svg";